import {
    GENERAL_CONFIGURATION_LABELS,
    DISPLAY_CONFIGURATION_LABELS,
    TOOLTIP_CONTENT,
    FOUR_SQUARE_GENERAL_LABELS,
    FOUR_SQUARE_DISPLAY_LABELS
} from './constants';

export function getFieldLabel(key: string): string {
    if (key in GENERAL_CONFIGURATION_LABELS) return GENERAL_CONFIGURATION_LABELS[key];
    return key;
}

export function getDisplayLabel(key: string): string {
    if (key in DISPLAY_CONFIGURATION_LABELS) return DISPLAY_CONFIGURATION_LABELS[key];
    return key;
}

export function hasFieldLabel(key: string): boolean {
    return key in GENERAL_CONFIGURATION_LABELS;
}

export function hasDisplayLabel(key: string): boolean {
    return key in DISPLAY_CONFIGURATION_LABELS;
}

export function hasFourSquareFieldLabel(key: string): boolean {
    return key in FOUR_SQUARE_GENERAL_LABELS;
}

export function hasFourSquareDisplayLabel(key: string): boolean {
    return key in FOUR_SQUARE_DISPLAY_LABELS;
}

export function getToolTipContent(key: string): string | null {
    if (key in TOOLTIP_CONTENT) return TOOLTIP_CONTENT[key];
    return null;
}

// Type guard to check if a display configuration entry has a displayName.
export function hasDisplayName(config: unknown): config is { displayName: string } {
    return typeof (config as { displayName?: unknown }).displayName === 'string';
}
